
import SecondaryButton from "./common/secondary-btn";
import IndustryList from "./industrylist";
export default function IndustrySlide({toggleModal, id})
{

const title="Industries We Serve";
const subs ="We provide tailored Stripe integration solutions for a wide range of industries, ensuring seamless and secure payment processing. Whether you need online payments, in-person transactions, or marketplace management, our solutions are designed to meet the unique needs of your industry. Let us help you streamline your payment processes and enhance your customer experience. ";

    return(
        <>
        <hr className="mt-[40px]"></hr>
        <section id={id}className="section-1  my-[60px] ">
        <div className="container mx-auto xl:px-0 lg:px-8 md:px-6 px-4">
            <div className="text-center">
                <h1 className='lg:text-[55px]  text-[35px]  mb-0 font-bold text-[#262626] relative inline-block'>{title} <span className=" rounded-[20px] w-[80px] m-auto h-[5px] bg-[#FB802C] block"></span></h1>
                <p className="text-center text-[#262626] text-[16px] font-regular pt-[20px] max-w-[720px] mx-auto">{subs}</p>
            </div>
            </div>  
            <div className="pt-[70px] pb-[70px]">
            <IndustryList/>
            </div>

            <div  className="mt-3 text-center"> <SecondaryButton  title="Talk to an Expert"  toggleModal={toggleModal}/></div>  
    
    </section>
    <hr className="mb-[60px]"></hr>
    </>

    )
}